import { render, staticRenderFns } from "./ProductSelector.vue?vue&type=template&id=6b896e10&scoped=true"
import script from "./ProductSelector.vue?vue&type=script&lang=js"
export * from "./ProductSelector.vue?vue&type=script&lang=js"
import style0 from "./ProductSelector.vue?vue&type=style&index=0&id=6b896e10&prod&lang=scss"
import style1 from "./ProductSelector.vue?vue&type=style&index=1&id=6b896e10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b896e10",
  null
  
)

export default component.exports